import * as React from 'react';

function SvgImageIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#21BA30" />
      <g clipPath="url(#image-icon_svg__clip0)" fill="#232340">
        <path d="M15.604 16.844a2.188 2.188 0 100-4.375 2.188 2.188 0 000 4.375z" />
        <path d="M19.51 10.573h-.768a.312.312 0 01-.281-.202c-.36-.76-.733-1.548-1.544-1.548H14c-.624 0-.954.454-1.55 1.278-.225.307-.298.472-.493.472h-3.5c-1.204 0-1.457.705-1.457 1.296v6.06a1.315 1.315 0 001.491 1.394H19.51A1.315 1.315 0 0021 17.929v-6.06c0-.591-.258-1.296-1.49-1.296zm-.551 4.083a3.355 3.355 0 11-6.71 0 3.355 3.355 0 016.71 0zM9.917 12.76a.73.73 0 11-1.459 0 .73.73 0 011.459 0z" />
        <path d="M8.458 9.98l1.75.01a.292.292 0 00.292-.292v-.146a.875.875 0 00-.875-.875H9.04a.875.875 0 00-.875.875v.137a.292.292 0 00.292.291z" />
      </g>
      <defs>
        <clipPath id="image-icon_svg__clip0">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgImageIcon;
